<h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>{{this.localiser.get("users.projectsOf")}} {{data.usuario.nombre}} {{data.usuario.apellidos}} - {{data.empresa.nombre}}</h1>

<div mat-dialog-content style="height: 70%" *ngIf="data.empresa.proyectos.length > 0">
  <div *ngFor="let proyecto of data.empresa.proyectos" style="text-align: center">
      <mat-checkbox class="textS" [checked]="containsProyecto(proyecto)" (change)="change(proyecto.idProyecto, $event.checked)">
        {{proyecto.nombre}}
      </mat-checkbox>
  </div>
</div>

<div mat-dialog-content class="bodyForm" *ngIf="data.empresa.proyectos.length <= 0">
  <div class="middleText">
    <h3 class="textM centerVert">{{this.localiser.get("users.noProjects")}} {{data.empresa.nombre}}</h3>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>
</div>
